import React, { createContext, useContext, useState, ReactNode } from "react";

// Définition des types pour une tâche en cours
interface Task {
  id: string;
  message: string;
  progress?: number | "indeterminate"; // 0 - 100 si une barre de progression est nécessaire
}

interface StatusBarContextType {
  tasks: Task[];
  addTask: (task: Task) => void;
  updateTask: (id: string, progress: number) => void;
  removeTask: (id: string) => void;
}

const StatusBarContext = createContext<StatusBarContextType | undefined>(undefined);

export const StatusBarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tasks, setTasks] = useState<Task[]>([]);

  const addTask = (task: Task) => {
    setTasks((prev) => [...prev, task]);
  };

  const updateTask = (id: string, progress: number) => {
    setTasks((prev) => prev.map((task) => (task.id === id ? { ...task, progress } : task)));
  };

  const removeTask = (id: string) => {
    setTasks((prev) => prev.filter((task) => task.id !== id));
  };

  return (
    <StatusBarContext.Provider value={{ tasks, addTask, updateTask, removeTask }}>
      {children}
    </StatusBarContext.Provider>
  );
};

export const useStatusBar = (): StatusBarContextType => {
  const context = useContext(StatusBarContext);
  if (!context) {
    throw new Error("useStatusBar must be used within a StatusBarProvider");
  }
  return context;
};
